export const messagesEndpoint = (limit, query = null) => {
  const searchParams = new URLSearchParams();
  if (limit) {
    searchParams.append("limit", limit);
  }

  if (query) {
    searchParams.append("query", query);
  }

  const baseUrl = "messages";
  const encodedSearchParams = searchParams.toString();
  return encodedSearchParams?.length
    ? `${baseUrl}?${encodedSearchParams}`
    : `${baseUrl}`;
};
